import { render, staticRenderFns } from "./CreateCampaignHeader.vue?vue&type=template&id=f960fd68&scoped=true"
import script from "./CreateCampaignHeader.vue?vue&type=script&lang=js"
export * from "./CreateCampaignHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f960fd68",
  null
  
)

export default component.exports